import { Box, Button } from '@betterment/samba-react';

import ErrorMessage from './ErrorMessage';
import RoadBlockIcon from './RoadBlockIcon';

const PartialErrorFallback = () => {
  return (
    <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 'space.300' }}>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'space.300',
          textAlign: 'center',
        }}
      >
        <RoadBlockIcon />
        <ErrorMessage />
        <Button css={{ width: '100%' }} onClick={() => window.location.reload()}>
          Reload
        </Button>
      </Box>
    </Box>
  );
};

export default PartialErrorFallback;
